module.exports = __webpack_public_path__ + "static/media/three-columns.ba5f9835.svg";